import { StylishNewButton } from 'components/DesignSystems/New/StylishNewButton';
import { SharedIcon } from 'components/SharedIcon/SharedIcon';
import { useLayerSidebarPanel } from './LayerSidebarPanel';
import { useUscgMapContext } from './UscgMapContext';
import type { InternalLayer } from 'hooks/internalLayer/types';
import { useListInternalLayerVersionsQuery } from 'hooks/internalLayerVersion/useListInternalLayerVersionsQuery';

// disabled if 'DRAFT' or 'PENDING' internal_layer_version already exists
export function DraftNewVersionButton({
  internalLayer,
}: {
  internalLayer: InternalLayer;
}) {
  const { setActivePanel } = useLayerSidebarPanel();
  const { setSidebarSelectedInternalLayer } = useUscgMapContext();

  const versions = useListInternalLayerVersionsQuery({
    filter: {
      internalLayerId: internalLayer.id,
    },
  });
  const draftExists = versions.data?.data?.find((v) =>
    ['DRAFT', 'PENDING'].includes(v.approval?.approvalStatus || '')
  );

  return (
    <StylishNewButton
      disabled={Boolean(draftExists)}
      title={
        draftExists
          ? 'Draft or pending version already exists'
          : 'Create a new draft version'
      }
      className={'button--primary pe-auto'}
      onClick={() => {
        setSidebarSelectedInternalLayer(internalLayer);
        setActivePanel('draft_new_version');
      }}
    >
      <SharedIcon iconName="add" size="sm" />
      Draft New Version
    </StylishNewButton>
  );
}
